import * as React from 'react';

type AppLibraryContextType = {
  isPopperOpen: boolean;
  openPopper: () => void;
  closePopper: () => void;
};

const AppLibraryContext = React.createContext<AppLibraryContextType | null>(
  null
);

const useAppLibraryContext = (): AppLibraryContextType => {
  const value = React.useContext(AppLibraryContext);

  if (!value) {
    throw new Error(
      'useAppLibraryContext should be used inside AppLibraryContextProvider'
    );
  }

  return value;
};

const AppLibraryContextProvider: React.FunctionComponent = (props) => {
  const [isPopperOpen, setState] = React.useState(false);

  const openPopper = () => {
    setState(true);
  };

  const closePopper = () => {
    setState(false);
  };

  return (
    <AppLibraryContext.Provider
      value={{ isPopperOpen, openPopper, closePopper }}
      {...props}
    />
  );
};

export { AppLibraryContextProvider, useAppLibraryContext };
